export const PAGE_CONFIG = {
  title: 'Retention',
  titleCN: '留存',
  subTitle: '',
  subTitleCN: '',
  path: '/retention/index',
  defaultTab: 'newUsers',
  tabList: [
    {
      id: 'newUsers',
      tabName: 'New Users',
      tabNameCN: '新进留存分析',
      isHaveNotification: true,
      notificationPath: '/retention/index/newUsers',
      path: '/retention/index/newUsers',
      logConfig: {
        pageId: '200801',
        pageName: 'engaementRetentionNewUsers',
        extInfo: 'engaementRetentionNewUsers',
        pagePath: '/retention/index/newUsers',
      },
      filters: [
        {
          name: 'RetentionMobileFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/newUsers',
          componentList: [
            {
              name: "RetentionChartContentCo",
              className: "",
              type: "view",
              style: {},
              props: {
              },
              children: [
                {
                  name: 'NightingaleLineChartCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/retention/linechart',
                      iconList: ['eyes', 'lineChart'],
                      componentMetrics: [
                        {
                          metricKey: 'd2',
                          reqMetricKey: 'd2',
                          enName: 'D2',
                          cnName: '次留',
                          rangeEnName: 'Average D2',
                          rangeCnName: '平均次留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d2',
                        },
                        {
                          metricKey: 'd3',
                          reqMetricKey: 'd3',
                          enName: 'D3',
                          cnName: '3留',
                          rangeEnName: 'Average D3',
                          rangeCnName: '平均3留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d3',
                        },
                        {
                          metricKey: 'd7',
                          reqMetricKey: 'd7',
                          enName: 'D7',
                          cnName: '7留',
                          rangeEnName: 'Average D7',
                          rangeCnName: '平均7留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d7',
                        },
                      ],
                      title: 'D2/3/7 Retention New Users',
                      titleCN: '新进用户 次留/3留/7留',
                      isHaveTitle: true,
                      isHaveSubTitle: true,
                      enChartTooltipsName: 'New Users Retention',
                      cnChartTooltipsName: '新进用户留存',
                    }
                  },
                  data: {
                    tag: 'new',
                    timeTypeIsShowCom: ['day']
                  }
                },
              ]
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'New',
                      cnName: '注册',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },

                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Retention New Users',
                  titleCN: '新进用户留存',
                }
              },
              data: {
                tag: 'new',
                retentionColumsNum: '2'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'activeUsers',
      tabName: 'Active Users',
      tabNameCN: '活跃留存分析',
      isHaveNotification: true,
      notificationPath: '/retention/index/activeUsers',
      path: '/retention/index/activeUsers',
      logConfig: {
        pageId: '200802',
        pageName: 'engaementRetentionActiveUsers',
        extInfo: 'engaementRetentionActiveUsers',
        pagePath: '/retention/index/activeUsers',
      },
      filters: [
        {
          name: 'RetentionMobileFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/activeUsers',
          componentList: [
            {
              name: "RetentionChartContentCo",
              className: "",
              type: "view",
              style: {},
              props: {
              },
              children: [
                {
                  name: 'NightingaleLineChartCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/retention/linechart',
                      componentMetrics: [
                        {
                          metricKey: 'd2',
                          reqMetricKey: 'd2',
                          enName: 'D2',
                          cnName: '次留',
                          rangeEnName: 'Average D2',
                          rangeCnName: '平均次留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d2',
                        },
                        {
                          metricKey: 'd3',
                          reqMetricKey: 'd3',
                          enName: 'D3',
                          cnName: '3留',
                          rangeEnName: 'Average D3',
                          rangeCnName: '平均3留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d3',
                        },
                        {
                          metricKey: 'd7',
                          reqMetricKey: 'd7',
                          enName: 'D7',
                          cnName: '7留',
                          rangeEnName: 'Average D7',
                          rangeCnName: '平均7留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d7',
                        },
                      ],
                      iconList: ['eyes', 'lineChart'],
                      title: 'D2/3/7 Retention Active Users',
                      titleCN: '活跃用户 次留/3留/7留',
                      isHaveTitle: true,
                      isHaveSubTitle: true,
                      enChartTooltipsName: 'Active Users Retention',
                      cnChartTooltipsName: '活跃用户留存',
                    }
                  },
                  data: {
                    tag: 'active',
                    timeTypeIsShowCom: ['day']
                  }
                },
              ]
            },
            {
              name: 'RetentionTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/retention/table',
                    tableDownloadApi: '/api/v1/dashboard/retention/table/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'Active Users',
                      cnName: '活跃用户',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Retention Active Users',
                  titleCN: '活跃用户留存',
                }
              },
              data: {
                tag: 'active',
                retentionColumsNum: '2'
              }
            },
          ]
        },
      ],
    },
    {
      id: 'returnUsers',
      tabName: 'Return Users',
      tabNameCN: '回流留存分析',
      isHaveNotification: true,
      notificationPath: '/retention/index/returnUsers',
      path: '/retention/index/returnUsers',
      logConfig: {
        pageId: '200803',
        pageName: 'engaementRetentionReturnUsers',
        extInfo: 'engaementRetentionReturnUsers',
        pagePath: '/retention/index/returnUsers',
      },
      filters: [
        {
          name: 'RetentionMobileFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: 'retention/index/returnUsers',
          componentList: [
            {
              name: "RetentionChartContentCo",
              className: "",
              type: "view",
              style: {},
              props: {
              },
              children: [
                {
                  name: 'RetentionTrendCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/engagement/retention/trend',
                      componentMetrics: [
                        {
                          metricKey: 'd2',
                          reqMetricKey: 'd2',
                          enName: 'D2',
                          cnName: '次留',
                          rangeEnName: 'Average D2',
                          rangeCnName: '平均次留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d2',
                        },
                        {
                          metricKey: 'd3',
                          reqMetricKey: 'd3',
                          enName: 'D3',
                          cnName: '3留',
                          rangeEnName: 'Average D3',
                          rangeCnName: '平均3留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d3',
                        },
                        {
                          metricKey: 'd7',
                          reqMetricKey: 'd7',
                          enName: 'D7',
                          cnName: '7留',
                          rangeEnName: 'Average D7',
                          rangeCnName: '平均7留',
                          type: 'percent',
                          decimal: 2,
                          avgResKey: 'avg_d7',
                        },
                      ],
                      iconList: ['eyes', 'lineChart'],
                      title: 'D2/3/7 Retention Return Users',
                      titleCN: '回流用户 次留/3留/7留',
                      isHaveTitle: true,
                      isHaveSubTitle: true,
                      enChartTooltipsName: 'Return Users Retention',
                      cnChartTooltipsName: '回流用户留存',
                    }
                  },
                  data: {
                    tag: 'return',
                    timeTypeIsShowCom: ['day']
                  }
                },
              ]
            },
            {
              name: 'RetentionReturnTableCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/engagement/retention/overall_performance',
                    tableDownloadApi: '/api/v1/dashboard/engagement/retention/overall_performance/download',
                  },
                  componentMetrics: [
                    {
                      enName: 'Return Users',
                      cnName: '回流用户',
                      metricsKey: 'return_users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                  ],
                  keyDaysConfig: [
                    {
                      value: 0,
                      enName: 'Key Days',
                      cnName: '关键日'
                    },
                    {
                      value: 30,
                      enName: '1 ~ 30 Days',
                      cnName: '1 ~ 30 日'
                    },
                    {
                      value: 60,
                      enName: '1 ~ 60 Days',
                      cnName: '1 ~ 60 日'
                    },
                    {
                      value: 90,
                      enName: '1 ~ 90 Days',
                      cnName: '1 ~ 90 日'
                    }
                  ],
                  title: 'Retention Return Users',
                  titleCN: '回流用户留存',
                }
              },
              data: {
                tag: 'return',
                retentionColumsNum: '2'
              }
            },
          ]
        },
      ],
    }
  ],
}